import { api } from "@/api/client";

export interface BackupCsvResult {
  blob: Blob;
  filename: string;
  erros: string[] | null;
  decodeFalhou: boolean;
}

// Porte de exportacao-backup-csv.controller.js. O header X-Backup-Erros vem
// em base64 de um JSON UTF-8 — o legado decodifica com o truque clássico
// `decodeURIComponent(escape(atob(...)))` (atob só lida com Latin1); mantido
// idêntico aqui pra não quebrar acentuação nas mensagens de erro.
export async function gerarBackupCsv(instituicaoId: number): Promise<BackupCsvResult> {
  const response = await api.get(`relatorio/RelatorioBackupCsv/${instituicaoId}`, {
    responseType: "arraybuffer",
  });

  const blob = new Blob([response.data], { type: "application/zip" });
  const filename = `BackupCsv${7000 + instituicaoId}.zip`;

  const headerErros = response.headers["x-backup-erros"];
  let erros: string[] | null = null;
  let decodeFalhou = false;
  if (headerErros) {
    try {
      const json = decodeURIComponent(escape(atob(headerErros)));
      erros = JSON.parse(json);
    } catch {
      decodeFalhou = true;
    }
  }

  return { blob, filename, erros, decodeFalhou };
}
